import { useState } from "react";
import { connectTopics } from "../../../mocks/chiagua";

const tags = ["全部", "娱乐", "剧集", "选秀", "知识", "综合", "争议"];

const tagColors: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700 border-primary-200",
  accent: "bg-accent-100 text-accent-800 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

export default function ConnectSection() {
  const [active, setActive] = useState("全部");
  const [joined, setJoined] = useState<number[]>([]);
  const list = active === "全部" ? connectTopics : connectTopics.filter((t) => t.tag === active);

  const toggle = (id: number, full: boolean) => {
    if (full) return;
    setJoined((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  return (
    <section id="connect" className="bg-background-100 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-accent-700 text-sm font-semibold tracking-widest">VOICE CONNECT</span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mt-2">连麦吃瓜 · 观点直接碰撞</h2>
          <p className="text-foreground-600 text-sm md:text-base mt-3">
            不愿只看弹幕？上麦聊聊你的看法。真实讨论、理性对线，连麦环节让不同立场面对面。
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 mt-6">
          {tags.map((t) => (
            <button
              key={t}
              onClick={() => setActive(t)}
              className={`px-4 py-2 rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer ${
                active === t
                  ? "bg-accent-500 text-background-50 font-medium"
                  : "bg-background-50 text-foreground-600 border border-background-200 hover:border-accent-400 hover:text-accent-800"
              }`}
            >
              {t}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 mt-8">
          {list.map((topic) => {
            const isJoined = joined.includes(topic.id);
            const isFull = topic.slots === "已满";
            const colorIdx = topic.id % 3;
            const colorKey = colorIdx === 0 ? "primary" : colorIdx === 1 ? "accent" : "secondary";
            return (
              <div
                key={topic.id}
                className="bg-background-50 border border-background-200/70 rounded-2xl p-5 hover:border-accent-300 transition-colors flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <span
                    className={`inline-flex items-center px-2.5 py-1 rounded-full border text-xs whitespace-nowrap ${
                      tagColors[colorKey]
                    }`}
                  >
                    {topic.tag}
                  </span>
                  <span
                    className={`inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full whitespace-nowrap ${
                      isFull ? "bg-background-200/70 text-foreground-500" : "bg-accent-100 text-accent-800"
                    }`}
                  >
                    {isFull ? "已满" : topic.slots}
                  </span>
                </div>
                <h3 className="text-foreground-950 font-semibold text-base leading-snug mt-4 flex-1">
                  {topic.title}
                </h3>
                {/* 声音波形示意 */}
                <div className="flex items-end gap-1 h-8 mt-4 mb-4">
                  {Array.from({ length: 12 }).map((_, i) => (
                    <span
                      key={i}
                      className={`w-1 rounded-full ${isFull ? "bg-background-300" : "bg-accent-500"}`}
                      style={{
                        height: "100%",
                        animation: isFull ? "none" : "voiceBar 0.9s ease-in-out infinite",
                        animationDelay: `${(i % 5) * 0.12}s`,
                        transform: `scaleY(${0.4 + ((i * 37) % 5) * 0.14})`,
                      }}
                    ></span>
                  ))}
                  <span className="ml-2 text-foreground-500 text-xs inline-flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i>
                    {topic.viewers}围观
                  </span>
                </div>
                <button
                  onClick={() => toggle(topic.id, isFull)}
                  className={`w-full px-4 py-3 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer inline-flex items-center justify-center gap-2 ${
                    isFull
                      ? "bg-background-200/70 text-foreground-400 cursor-not-allowed"
                      : isJoined
                        ? "bg-accent-500 text-background-50"
                        : "bg-primary-500 hover:bg-primary-600 text-background-50"
                  }`}
                >
                  <i className={isJoined ? "ri-check-line" : "ri-mic-line"}></i>
                  {isFull ? "麦位已满" : isJoined ? "已排队，等待上麦" : "想连麦"}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}